import React from 'react';
export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}
export function Label({
  className = '',
  ...props
}: LabelProps) {
  return <label className={`text-sm font-medium leading-none text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`} {...props} data-id="element-122" />;
}